import React from "react";
import { RenderKilogramo } from "../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../Utils/renderField/nullableValue";
import "./styles/Almacenes.css";

export const ResumenRecepcionesDRC = (props) => {
    const { datosAlmacen = {}, movimientos = [] } = props;

    const totales = {
        analisis_drc: {
            kg_humedos: datosAlmacen.kg_humedos_analisis
                ? datosAlmacen.kg_humedos_analisis
                : null,
            kg_secos_lab: datosAlmacen.kg_secos_analisis_lab
                ? datosAlmacen.kg_secos_analisis_lab
                : null,
            kg_secos_liq: datosAlmacen.kg_secos_analisis_liq
                ? datosAlmacen.kg_secos_analisis_liq
                : null,
        },
        ids_no_utilizados: {
            kg_humedos: movimientos.reduce(
                (total, recepcion) =>
                    total + (recepcion.kg_humedos ? recepcion.kg_humedos : 0),
                0,
            ),
            kg_secos_lab: movimientos.reduce(
                (total, recepcion) =>
                    total +
                    (recepcion.kg_secos_lab ? recepcion.kg_secos_lab : 0),
                0,
            ),
            kg_secos_liq: movimientos.reduce(
                (total, recepcion) =>
                    total +
                    (recepcion.kg_secos_liq ? recepcion.kg_secos_liq : 0),
                0,
            ),
        },
    };

    return (
        <React.Fragment>
            <h4 className="align-self-end mt-5 mb-3">
                Resumen de Recepciones y DRC
            </h4>

            {/* TABLA DE RESUMEN */}
            <div className="new-table-wrapper almacenes__table-wrapper">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th>MÉTODO</th>
                            <th>KILOS HÚMEDOS</th>
                            <th>KILOS SECOS LAB</th>
                            <th>KILOS SECOS LIQ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-center text-nowrap">
                                Análisis DRC de sobrante en almacén
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue
                                    value={totales.analisis_drc.kg_humedos}
                                >
                                    <RenderKilogramo
                                        value={totales.analisis_drc.kg_humedos}
                                        decimalScale={2}
                                    />
                                </NullableValue>
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue
                                    value={totales.analisis_drc.kg_secos_lab}
                                >
                                    <RenderKilogramo
                                        value={
                                            totales.analisis_drc.kg_secos_lab
                                        }
                                        decimalScale={3}
                                    />
                                </NullableValue>
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue
                                    value={totales.analisis_drc.kg_secos_liq}
                                >
                                    <RenderKilogramo
                                        value={
                                            totales.analisis_drc.kg_secos_liq
                                        }
                                        decimalScale={3}
                                    />
                                </NullableValue>
                            </td>
                        </tr>
                        <tr>
                            <td className="text-center text-nowrap">
                                IDs no utilizados
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue
                                    value={totales.ids_no_utilizados.kg_humedos}
                                >
                                    <RenderKilogramo
                                        value={
                                            totales.ids_no_utilizados.kg_humedos
                                        }
                                        decimalScale={2}
                                    />
                                </NullableValue>
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue
                                    value={
                                        totales.ids_no_utilizados.kg_secos_lab
                                    }
                                >
                                    <RenderKilogramo
                                        value={
                                            totales.ids_no_utilizados
                                                .kg_secos_lab
                                        }
                                        decimalScale={3}
                                    />
                                </NullableValue>
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue
                                    value={
                                        totales.ids_no_utilizados.kg_secos_liq
                                    }
                                >
                                    <RenderKilogramo
                                        value={
                                            totales.ids_no_utilizados
                                                .kg_secos_liq
                                        }
                                        decimalScale={3}
                                    />
                                </NullableValue>
                            </td>
                        </tr>
                        <tr className="modal-ingresos__totales-row">
                            <td className="text-center text-nowrap">
                                <strong>TOTALES</strong>
                            </td>
                            <td className="text-center text-nowrap">
                                {/* TOTAL DE KG HÚMEDOS */}
                                <RenderKilogramo
                                    value={totales.ids_no_utilizados.kg_humedos + totales.analisis_drc.kg_humedos}
                                    decimalScale={2}
                                />
                            </td>
                            <td className="text-center text-nowrap">
                                {/* TOTAL DE KG SECOS LAB */}
                                <RenderKilogramo
                                    value={totales.ids_no_utilizados.kg_secos_lab + totales.analisis_drc.kg_secos_lab}
                                    decimalScale={3}
                                />
                            </td>
                            <td className="text-center text-nowrap">
                                {/* TOTAL DE KG SECOS LIQ */}
                                <RenderKilogramo
                                    value={totales.ids_no_utilizados.kg_secos_liq + totales.analisis_drc.kg_secos_liq}
                                    decimalScale={3}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    );
};
